import { BACK_TO_SIGN_IN } from './ResetPasswordConstants';

const initialState = {};

export default function resetPassword(state = initialState, action) {
  switch (action.type) {
    case 'CLOSE_MODAL':
    case BACK_TO_SIGN_IN:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}
